import React, {useReact} from 'react';
import { Row, Col } from 'react-bootstrap';

const View = (props) => {
    return (
        <div className="p-2">
            <div>
                Resi pengiriman
            </div>
            <div>
                <h5>{props.waybillId === "-" || !props.waybillId ? "Tidak ada" : props.waybillId}</h5>
                {
                    props.link ?
                        <a target='_blank' href={`${props.link}`}>
                        <u><b>Link Status Pengiriman</b></u>
                        </a> :
                        ""
                }
            </div>
        </div>
    )
}

export default View